import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'tg-modal';

import TrafoPreview from './TrafoPreview';
import { MediaItemShape } from '../utils/shapes';
import DeleteButton from './DeleteButton';

class AttachmentPreview extends Component {
    static propTypes = {
        file: PropTypes.instanceOf(File),
        mediaItem: MediaItemShape.isRequired,
        onDelete: PropTypes.func,
    };

    static defaultProps = {
        file: null,
        onDelete: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    toggleModal = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    render() {
        const { file, mediaItem, onDelete } = this.props;
        const { isOpen } = this.state;
        const shouldRenderModal = !mediaItem.isPdf;
        const canPlayMedia = (mediaItem.isVideo && mediaItem.videoUrl) || (mediaItem.isAudio && mediaItem.audioUrl);
        return (
            <div className="attachment-preview">
                {shouldRenderModal && (
                    <Modal
                        isOpen={isOpen}
                        onCancel={this.toggleModal}
                        dialogClassName="tg-modal-dialog tg-modal-wide"
                        title={mediaItem.title}
                        autoWrap
                    >
                        <TrafoPreview
                            file={file}
                            mediaItem={mediaItem}
                            size="large"
                            finishedLoadingCallback={canPlayMedia ? DJ_CONST.initTrafoVideoAndAudio : undefined}
                            showUnavailable
                            showPreview={canPlayMedia}
                        />
                    </Modal>
                )}
                <TrafoPreview
                    file={file}
                    mediaItem={mediaItem}
                    size="small"
                    onClick={shouldRenderModal ? this.toggleModal : undefined}
                />
                <div className="attachment-preview__content">
                    <div className="text">{mediaItem.title}</div>
                    {onDelete && (
                        <div className="ml-2">
                            <DeleteButton onClick={() => onDelete(mediaItem.id)} />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default AttachmentPreview;



// WEBPACK FOOTER //
// ./src/components/AttachmentPreview.js